/**
 * 自定义指令集 v-xxxxx
 */
import Vue from 'vue'
import {
  Message
} from 'element-ui'

/**
 * 复制
 */
export const copy = {
  bind(el, {
    value
  }) {
    el.$value = value;
    el.$handler = function() {
      if (!el.$value) {
        Message.error(Vue.prototype.$bus.$ts('复制成功'))
        return
      }
      const textarea = document.createElement('textarea');
      textarea.readOnly = 'readonly';
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      textarea.value = el.$value;
      document.body.appendChild(textarea)
      textarea.select();
      const result = document.execCommand('Copy');
      if (result) {
        Message.success(Vue.prototype.$bus.$ts('复制成功'))
      }
      document.body.removeChild(textarea)
    }
    el.addEventListener('click', el.$handler)
  },
  componentUpdated(el, {
    value
  }) {
    el.$value = value;
  },
  unbind(el) {
    el.removeEventListener('click', el.$handler)
  }
}

/**
 * 防抖
 */
export const debounce = {
  inserted: function(el, binding) {
    let timer,
      timeout = 500;
    if (binding.arg && !isNaN(binding.arg)) {
      timeout = binding.arg || 500;
    }
    el.addEventListener('click', () => {
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => {
        binding.value()
      }, timeout)
    })
  }
}

/**
 * v-scroll 滚动监听指令
 */
export const scroll = {
  bind(el, binding) {
    el.addEventListener('scroll', function() {
      binding.value(this.scrollTop)
    })
  }
}

/**
 * aria-hidden报错
 */
// export const removeAriaHidden = {
//   bind(el, binding) {
//     let ariaEls = el.querySelectorAll('[aria-hidden]');
//     ariaEls.forEach(item => {
//       item.removeAttribute('aria-hidden')
//     })
//   }
// }
const isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const mousewheelFn = isFirefox ? 'DOMMouseScroll' : 'mousewheel';
// 对应input[type="number"]所有添加禁止滚轮操作改变数字
export const mousewheel = {
  bind(el, binding) {
    if (el && el.addEventListener) {
      el.addEventListener(mousewheelFn, function(e) {
        e.preventDefault();
      });
    }
  }
}

/**
 * el-select 组件 滚动加载指令 v-selectLoad:className="fn" popper-class="className"
 */
export const selectLoad = {
  bind(el, binding) {
    const selectScroll = el.querySelector(`.${binding.arg} .el-select-dropdown__wrap`);
    if (selectScroll) {
      selectScroll.addEventListener('scroll', function() {
        const condition = this.scrollHeight - this.scrollTop.toFixed(0) <= this.clientHeight + 34 * 3;
        if (condition) binding.value()
      })
    }
  },
  unbind(el, binding) {
    const selectScroll = el.querySelector(`.${binding.arg}`);
    selectScroll && selectScroll.remove()
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/directives.js